/**
 * Convert string to lower camel case
 */
const toLowerCamelCase = (str: string): string => {
  return str
    .replace(/[-_\s]+(.)?/g, (_, char) => (char ? char.toUpperCase() : ''))
    .replace(/^[A-Z]/, (char) => char.toLowerCase());
};

/**
 *  オブジェクトのキーをlowerCamelCaseに変換する関数
 * @param obj - 変換対象のオブジェクト
 */
export const convertObjectToLowerCamelCase = (obj: any): any => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertObjectToLowerCamelCase(item));
  }

  if (typeof obj === 'object') {
    const converted: any = {};
    for (const [key, value] of Object.entries(obj)) {
      const camelKey = toLowerCamelCase(key);
      converted[camelKey] = convertObjectToLowerCamelCase(value);
    }
    return converted;
  }

  return obj;
};

/**
 *  JSON文字列をパースして、キーをlowerCamelCaseに変換する関数
 * @param jsonString - JSON形式の文字列
 */
export const convertJsonToLowerCamelCase = (jsonString: string): any => {
  try {
    const parsed = JSON.parse(jsonString);
    return convertObjectToLowerCamelCase(parsed);
  } catch (error) {
    throw new Error('Invalid JSON string');
  }
};
